import styled from 'styled-components/macro';

const CopyrightWrapper = styled.div`
  position: absolute;
  bottom: 5px;
  width: calc(100% - 60px);

  .placeholder,
  .public-DraftEditor-content {
    opacity: 0.7;
    font-size: 12px;
  }

  .public-DraftEditor-content {
    max-height: 3em;
    overflow-y: auto;
  }
`;

export default CopyrightWrapper;
